var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.745,
    height: 48.745,
    viewBox: "0 0 48.745 48.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "javascript",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M6,54.745V6H54.745V54.745Z",
    fill: "#ffd600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M34.567,36.823c.937,1.522,1.955,2.98,4.112,2.98,1.812,0,2.762-.9,2.762-2.146,0-1.491-.983-2.02-2.976-2.888L37.373,34.3c-3.154-1.338-5.251-3.014-5.251-6.555,0-3.263,2.5-5.746,6.4-5.746a6.468,6.468,0,0,1,6.218,3.484l-3.4,2.176A2.973,2.973,0,0,0,38.523,25.8a1.9,1.9,0,0,0-2.092,1.864c0,1.305.812,1.833,2.688,2.642l1.093.466c3.717,1.583,5.813,3.2,5.813,6.834,0,3.916-3.093,6.062-7.244,6.062a7.989,7.989,0,0,1-7.65-4.56Zm-15.688.111A3.7,3.7,0,0,0,22.1,39.1c1.433,0,2.257-.566,2.257-2.766V22h4.513V37.031c0,4.559-2.644,6.633-6.506,6.633a7.919,7.919,0,0,1-7.034-4.56Z",
    transform: "translate(3.304 5.664)",
    fill: "#000001"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.333c9ca301c4295b40b47e89442f536e.svg";
export { ForwardRef as ReactComponent };